import { createAsyncThunk } from "@reduxjs/toolkit";
import { QuestionData } from "./interfaces/frontend";
import { QuestionDataResponse } from "./interfaces/backend";
import { convertToCamelCase } from "../../../../../utility/convertToCamelCase";
//import { SERVER_DOMAIN } from "../../../../../constants";
import { serverDetails } from "../../../constants/staticContents";

// login thunk is called only when on enter mobile number view
export const loadQuestionsDataArray = createAsyncThunk(
  "questionsDataArraySlice/loadQuestionsDataArray",
  async ({ token, questionIds }: LoadQuestionsDataArrayArgs) => {
    try {
      // resend : number, 0 -> ...
      // ?page=${currentPageNumber}
      const url = questionIds 
        ? `${serverDetails}/content/questions-proofread/?question_ids=${questionIds}`
        : `${serverDetails}/content/questions-proofread/`;
      const response = await fetch(
        url,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const responseData = await response.json();
      
      // Check if response contains an error detail even with 200 status
      if (responseData.detail) {
        throw new Error(responseData.detail);
      }

      if (!response.ok) {
        throw new Error(responseData.detail || 'Failed to load questions');
      }

      const questionsDataArrayResponse: QuestionDataResponse[] = responseData?.results || [];
      
      const loadQuestionsDataArrayReturnValue: LoadQuestionsDataArrayReturnValue =
        {
          questionsDataArray: questionsDataArrayResponse.map((item) => {
            return convertToCamelCase({ ...item, editStatus: "pending" });
          }),
        };

      return loadQuestionsDataArrayReturnValue;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
);

export interface LoadQuestionsDataArrayArgs {
  token: string;
  questionIds?: string;
}

export interface LoadQuestionsDataArrayReturnValue {
  questionsDataArray: QuestionData[];
}
